// import logo from "./logo.svg";
import "./App.css";
// import LottieAnimation from "./Lottie/LottieAnimation.js";
// import comingSoon from "./Animation/lf30_editor_o1dorqvu.json";
// import lottie from "./Animation/15003-lottie-coming-soon.json";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import Home from "./pages/Home";
import FormResetPassword from "./pages/FormResetPassword";
import SuccessResetPassword from "./pages/SuccessResetPassword";
import withRoot from "./withRoot";
import { useTheme } from "@material-ui/core/styles";
import React from "react";
import { useTranslation } from "react-i18next";
import ButtonAppBar from "./components/ButtonAppBar";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import WorkingWithUs from "./pages/WorkingWithUs";
import TermsAsk from "./pages/TermsAsk";
import PrivacyAsk from "./pages/PrivacyAsk";

function App() {
  const theme = useTheme();

  const { t, i18n } = useTranslation();

  React.useEffect(() => {
    i18n.changeLanguage("ar");
    document.body.dir = i18n.dir();
    theme.direction = i18n.dir();
  }, [theme, i18n]);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    document.body.dir = i18n.dir();
    theme.direction = i18n.dir();
  };

  return (
    <BrowserRouter t={t} i18n={i18n} changeLanguage={changeLanguage}>
      <ButtonAppBar t={t} i18n={i18n} changeLanguage={changeLanguage} />

      <div className="container mt-2" style={{ marginTop: 20 }}>
        <Switch>
          <Route exact path="/">
            <Home t={t} i18n={i18n} />
          </Route>
          {/* <Route path="/forget-password">
            <SignIn />
          </Route> */}
          <Route path={`/reset-password/:token`}>
            <FormResetPassword />
          </Route>
          <Route path={`/successResetPassword`}>
            <SuccessResetPassword />
          </Route>
          <Route path={`/ask/privacy`}>
            <PrivacyAsk />
          </Route>
          <Route path={`/privacy`}>
            <Privacy />
          </Route>
          <Route path={`/terms`}>
            <Terms />
          </Route>
          <Route path={`/ask/terms`}>
            <TermsAsk />
          </Route>
          <Route path={`/working-with-us`}>
            <WorkingWithUs />
          </Route>
        </Switch>
      </div>
    </BrowserRouter>
  );
}

export default withRoot(App);
